import { Link } from "react-router-dom";
//import '../common/css/App.css';
//import '../common/css/newstuff.css';

export default function Menu() {
	return (
		<div>
			<h1>All Applications (v1.1.4)</h1>
			<nav
				style={{
					borderBottom: "solid 1px",
					paddingBottom: "1rem",
				}}
			>
				<table width='60%'>
					<tr>
						<td><Link to="http://www.remindertabs.com?user=demo">Reminder Tabs</Link></td>
						<td>Angular, Android App, Spring Boot Rest API, MySQL</td>
					</tr>
					<tr>
						<td><Link to="/">WLC</Link></td>
						<td>React, Spring Boot Rest API, MySQL</td>
					</tr>
					<tr>
						<td><Link to="/poker">Poker Utils</Link></td>
						<td>React, File Upload, Spring Boot Rest API, MySQL</td>
					</tr>
					<tr>
						<td><Link to="/restaurants?tag=mr21044">Restaurant Map</Link></td>
						<td>React, Leaflet, Spring Boot Rest API, MySQL</td>
					</tr>
					<tr>
						<td><Link to="/pools?tag=mr21044">Pool Map</Link></td>
						<td>React, Leaflet, NodeJS Rest API, MongoDB</td>
					</tr>
					<tr>
						<td><Link to="/cards">Card Games</Link></td>
						<td>React, Spring Boot Rest API</td>
					</tr>
					<tr>
						<td><Link to="/websockets">Send Websocket Message</Link></td>
						<td>React, Android App, Spring Boot Rest API</td>
					</tr>
				</table>
				<br />
			</nav>
		</div>
	);
}
